<template>
  <div @click.stop.prevent="gotoMatch(item)">
    <div class="match-card">
      <img
        class="thumb"
        :src="
          (language === 'zh'
            ? item.zhListImage
            : item.enListImage || item.zhListImage) | imageUrl('', 1080, 450)
        "
        alt
      />
      <p>{{ language === "zh" ? item.title : item.enTitle || item.title }}</p>
      <div class="footer">
        <!--<img :src="item.userAvatar | imageUrl('',30,30)" alt>
      <span class="nickname">{{item.userNickname}}</span>-->
        <span class="time"
          >{{ item.deliverStartTime | formatDate("YYYY-MM-DD")
          }}{{ $t("global.至")
          }}{{ item.deliverEndTime | formatDate("YYYY-MM-DD") }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {};
  },
  methods: {
    gotoMatch(item) {
      if (item.type == 1) {
        let routeData = this.$router.resolve({
          path: "/match/" + item.url,
        });
        window.open(routeData.href, "_blank");
      }
      if (item.type == 2) {
        window.open(item.url, "_blank");
      }
    },
  },
  computed: {
    language() {
      return this.$language();
    },
  },
};
</script>
<style scoped>
.match-card {
  display: flex;
  flex-direction: column;
}
.thumb {
  width: 538px;
  height: 225px;
}
.match-card p {
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  word-break: break-word;
  padding: 10px 20px 0;
  font-weight: bolder;
  height: 40px;
  line-height: 20px;
  color: #333;
}
.footer {
  margin-top: 10px;
  font-size: 12px;
  padding: 0 20px;
}
.footer img {
  width: 16px;
  height: 16px;
  border-radius: 8px;
  border: 1px solid #eaebec;
  vertical-align: top;
}
.footer span {
  color: #999;
}
.nickname {
  padding-left: 5px;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
.time {
}
</style>




// WEBPACK FOOTER //
// src/components/match/matchCard.vue